import "../common/ModalWindow.css";

import {useContext, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

import {backend} from "../model/Backend";
import SpinLoadingIndicator from "../common/SpinLoadingIndicator";
import {
    WallActions,
    WallContext,
    WallDispatchContext
} from "../contexts/WallContext";
import {UiUtils} from "../common/Utils";
import ModalWindow from "../common/ModalWindow";
import BasicTextInput from "../common/TextInput";
import {BasicButton, BasicButtonColor} from "../common/Button";
import ModifiableList from "../common/ModifiableList";
import ErrorMessage from "../common/ErrorMessage";

class SettingsState {
    static Saved = 1;
    static Dirty = 2;
    static Saving = 3;
}

export default function SettingsModal({onClose}) {
    const wall = useContext(WallContext);
    const wallDispatch = useContext(WallDispatchContext);

    const [formData, setFormDataRaw] = useState(wall.metadata);
    const [state, setState] = useState(SettingsState.Saved);
    const [errorData, setErrorData] = useState(null);
    const [message, setMessage] = useState(null);

    function setFormData(newFormData) {
        // TODO: compare with wallData to see if there really is a change
        setState(SettingsState.Dirty);

        setErrorData(null);
        setMessage(null);
        setFormDataRaw(newFormData);
    }

    function handleInputChange(event) {
        const {name, value} = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    }

    async function handleSave() {
        console.assert(state === SettingsState.Dirty);
        setState(SettingsState.Saving)
        setErrorData(null);
        setMessage(null);
        const result = await backend.saveWallMetadata(formData);
        if (!result.isSuccess()) {
            setState(SettingsState.Dirty);
            setErrorData(result);
        } else {
            setState(SettingsState.Saved);
            setMessage("Changes published.")
            wallDispatch({
                type: WallActions.SetMetadata,
                metadata: formData,
            });
        }
    }

    async function handleClose() {
        if (state === SettingsState.Dirty &&
            !await UiUtils.confirmAsync("Your changes were not published, do you want to discard them?")) {
            return;
        }
        if (state === SettingsState.Saving &&
            !await UiUtils.confirmAsync("Some changes might not yet been saved, do you want to exit?")) {
            return;
        }
        onClose();
    }

    return (
        <ModalWindow className="w-2/3" handleClose={handleClose}>
            <h1 className="text-4xl">Edit Wall Information</h1>
            <div className="mb-8"></div>
            <BasicTextInput
                label="Wall name"
                name="name"
                value={formData.name || ""}
                onChange={handleInputChange}
            />
            <div className="mb-5"></div>

            <BasicTextInput
                label="Location"
                name="location"
                value={formData.location || ""}
                onChange={handleInputChange}
            />
            <div className="mb-5"></div>

            <BasicTextInput
                label="Brief description"
                name="description"
                value={formData.description || ""}
                onChange={handleInputChange}
                textArea={true}
            />

            <div className="mb-5"></div>
            <h3 className="mb-1 font-bold text-lg">Builders</h3>
            <ModifiableList
                values={formData.builders}
                setValues={newBuilders => setFormData({
                    ...formData,
                    builders: newBuilders,
                })}
            />

            <div className="mb-5"></div>
            <h3 className="mb-1 font-bold text-lg">Difficulties</h3>
            <ModifiableList
                values={formData.difficulties}
                setValues={newDifficulties => setFormData({
                    ...formData,
                    difficulties: newDifficulties,
                })}
            />
            <div className="mb-5"></div>

            <ErrorMessage data={errorData}/>
            {message !== null &&
                <div>{message}</div>
            }
            <div className="mb-5"></div>
            <div className="flex justify-end space-x-4">
                <BasicButton onClick={handleClose}>Close</BasicButton>
                <BasicButton onClick={handleSave} disabled={state !== SettingsState.Dirty} buttonColor={BasicButtonColor.Blue}>
                    {state === SettingsState.Saving ? <SpinLoadingIndicator/> : "Publish"}
                </BasicButton>
            </div>
        </ModalWindow>
    );
};